import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import styles from "./Feedback.module.scss";
import useFeedback from "./useFeedback";
import useHasMounted from "hooks/useHasMounted/useHasMounted";

const cx = classNames.bind(styles);

export type FeedbackProps = {
    components: {
        heading: string;
        question: string;
        questionId: string;
        section?: string;
    };
};

export const Feedback = ({ components }: FeedbackProps) => {
    const { question, questionId, heading, section } = components;
    const { hasFeedback, isUseful, updateFeedback } = useFeedback(questionId);

    const hasMounted = useHasMounted();

    const dataLayerPush = (event: {
        event: string;
        section?: string;
        question: string;
        action: boolean;
    }) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    };

    const onClick = (isUseful: boolean) => {
        if (!hasFeedback) updateFeedback(isUseful);

        dataLayerPush({
            event: "faq_feedback",
            section: section,
            question: question,
            action: isUseful,
        });
    };

    if (!hasMounted) return null;

    return (
        <div className={cx("feedbackContainer")}>
            <span className={cx("feedbackTitle")}>{heading}</span>
            <div className={cx("iconContainer")}>
                <button
                    className={cx("iconButton", {
                        active: isUseful,
                    })}
                    onClick={() => onClick(true)}
                    disabled={hasFeedback}
                >
                    <UIIcon
                        svgProps={{ className: cx("positiveFeedback") }}
                        icon={hasFeedback && isUseful ? "ThumbsUpActive" : "ThumbsUp"}
                    />
                    <span className={cx("buttonLabel")}>Yes</span>
                </button>
                <button
                    className={cx("iconButton", {
                        active: !isUseful,
                    })}
                    onClick={() => onClick(false)}
                    disabled={hasFeedback}
                >
                    <UIIcon
                        icon={hasFeedback && !isUseful ? "ThumbsDownActive" : "ThumbsDown"}
                        svgProps={{
                            className: cx("negativeFeedback"),
                        }}
                    />
                    <span className={cx("buttonLabel")}>No</span>
                </button>
            </div>
        </div>
    );
};

export default Feedback;
